var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFema(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_11314)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3549 17.0122V18.6766H14.4609C15.2091 18.6766 15.8159 19.2834 15.8159 20.0316C15.8159 20.7798 15.2091 21.3866 14.4609 21.3866H13.3549V22.645C13.3549 23.3932 12.7482 24 12 24C11.2517 24 10.645 23.3932 10.645 22.645V21.3866H9.53859C8.79061 21.3866 8.18363 20.7797 8.18363 20.0316C8.18363 19.2836 8.79061 18.6766 9.53859 18.6766H10.645V17.0122C6.53409 16.3568 3.44006 12.7844 3.44006 8.55989C3.44006 3.83962 7.27964 0 12 0C16.7202 0 20.56 3.83958 20.56 8.55989C20.56 12.7845 17.466 16.3568 13.3549 17.0122ZM6.14981 8.55989C6.14981 11.7851 8.77477 14.4098 11.9999 14.4098C15.2252 14.4098 17.85 11.7852 17.85 8.55989C17.85 5.33456 15.2251 2.70998 11.9999 2.70998C8.77481 2.70998 6.14981 5.33466 6.14981 8.55989Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_11314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFema);
export default __webpack_public_path__ + "static/media/FEMA.6ac462856cc63c4e32384f379c432616.svg";
export { ForwardRef as ReactComponent };